module.exports = __webpack_public_path__ + "assets/images/assessment-completion.a2e3f55775f4a11b22275ce335cc8a20.svg";